import { render, staticRenderFns } from "./ClientDepositPercent.vue?vue&type=template&id=058aa79e"
import script from "./ClientDepositPercent.vue?vue&type=script&lang=js"
export * from "./ClientDepositPercent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports